module.exports = __webpack_public_path__ + "img/40.f7a658f1.png";